/**
 * @param e - event catched by the user. Should be mostly a click.
 * @param targetEl - the element that receive the effect. Better to give it directly than catching it with e.target because your component can have multiple children
 */
export function handleRippleEffect(e: MouseEvent, targetEl: HTMLElement) {
    if (targetEl) {
        const rect = targetEl.getBoundingClientRect();
        const rippleClass = 'joy-ripple-effect';
        let rippleEl;

        // We check if we hve already created the ripple span
        const alreadyCreatedRipple: HTMLSpanElement | null = targetEl.querySelector(`.${rippleClass}`);

        // When we first click there is no span yet, so we create it
        if (!alreadyCreatedRipple) {
            rippleEl = document.createElement('span');
            rippleEl.classList.add(rippleClass);
        }

        const actualRipple = alreadyCreatedRipple || rippleEl;
        targetEl.prepend(actualRipple!);

        const diameter = Math.sqrt(Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) * 2;

        actualRipple!.style.width = actualRipple!.style.height = `${diameter}px`;
        actualRipple!.style.left = `${e.clientX - rect.left}px`;
        actualRipple!.style.top = `${e.clientY - rect.top}px`;
    }
}
